/** Alinhado ao backend (`PEDIDO_INTEGRACAO_REPORT_MAX_DAYS`). */
export const PEDIDO_INTEGRACAO_REPORT_MAX_DAYS = 31;

function parseDateOnlyISO(iso: string): Date {
  const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(iso.trim());
  if (!m) {
    return new Date(NaN);
  }
  return new Date(Number(m[1]), Number(m[2]) - 1, Number(m[3]));
}

function differenceInCalendarDays(end: Date, start: Date): number {
  const utcEnd = Date.UTC(end.getFullYear(), end.getMonth(), end.getDate());
  const utcStart = Date.UTC(
    start.getFullYear(),
    start.getMonth(),
    start.getDate(),
  );
  return Math.round((utcEnd - utcStart) / 86400000);
}

export function validatePedidoIntegracaoReportPeriod(
  dataInicioISO: string,
  dataFimISO: string,
  maxDays = PEDIDO_INTEGRACAO_REPORT_MAX_DAYS,
): string | null {
  const dataInicio = parseDateOnlyISO(dataInicioISO);
  const dataFim = parseDateOnlyISO(dataFimISO);

  if (Number.isNaN(dataInicio.getTime()) || Number.isNaN(dataFim.getTime())) {
    return "Informe datas válidas no período.";
  }

  if (dataInicio.getTime() > dataFim.getTime()) {
    return "A data início deve ser anterior ou igual à data fim.";
  }

  const dias = differenceInCalendarDays(dataFim, dataInicio) + 1;
  if (dias > maxDays) {
    return `Período máximo de ${maxDays} dias para este relatório (selecionado: ${dias} dias). Reduza o intervalo e tente novamente.`;
  }

  return null;
}
